import * as React from 'react'
import Wait from "../wait";
import UgSpatial from "../../ug/ug_spatial";
import * as LF from "leaflet";
import Basemap from "../../ug/basemap";
import api from "../../service/api";
import GeoServer from "../../service/geoserser";
import PopDetail from "../popdetail";
import AddDeedPlanSpatialPane from "../add/add_deed_plan_spatial";
import AllocatePlotPane from "./plot/allocate_plot";

export default class FormalizationMapPane extends React.Component {



    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show_actions: this.props.can_edit ? 'table-cell' : 'none',
            selected_plots:[],
            description:[]
        }
        this.loadMap = this.loadMap.bind(this)
    }

    componentDidMount() {
        this.loadMap()
    }



    render() {

        return (<div className={'row'}>
            <div className={'col col-sm-12'} style={{padding:0}}>
                <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-map'} style={{marginRight: '8px'}}/>
                        Upload Layers
                    </span>



                    <button className={'btn submit'} style={{float:'right',marginBottom:'4px',marginTop:'-4px'}} onClick={()=>
                        PopDetail.show('Add New Layer',<AddDeedPlanSpatialPane project={this.props.project} loadData={this.loadMap} key={new Date().getMilliseconds()}/>)}>
                        <span className={'fa fa-plus'}/>Add Layer
                    </button>
                    <button onClick={()=>PopDetail.show('Allocate '+this.state.selected_plots.length+' Plots',<AllocatePlotPane project={this.props.project} description={this.state.description} deedplan={this.state.selected_plots} loadData={this.loadMap}  key={new Date().getMilliseconds()}/>)}
                        className={'btn error'} style={{float:'right',marginBottom:'4px',marginTop:'-4px',display:this.state.selected_plots.length>0?'inherit':'none'}}>
                        <span className={'fa fa-users'}/>Allocate ({this.state.selected_plots.length})
                    </button>

                </div>

                <div style={{height: '84vh'}}>



                    <div style={{height:'84vh',background:'#ddd'}} id={'ramani'}>

                    </div>

                </div>

            </div>


        </div>)
    }


    loadMap() {
        UgSpatial.clear()
        let self = this
        let ly_labels = new LF.FeatureGroup(),
            ly_beacons = new LF.FeatureGroup(),
            ly_plots = new LF.FeatureGroup()
        let sat = Basemap.googleSat(),
            hybrid = Basemap.googleHybrid(),
            gray = Basemap.backWhite(),
            blank = LF.tileLayer('')

        let map = UgSpatial.map==null?LF.map('map', {
            layers: [sat,ly_plots, ly_labels],
            attributionControl: false,
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: 'topleft'
            },
            maxZoom:10000
        }).setView([-6.085936, 35.711995], 6):UgSpatial.map


        let baseLayers = {
            'Gray':gray,
            "<span style='color: gray'>Blank</span>": blank,
            "Satellite": sat,
            "Hybrid": hybrid
        }


        /*let overlays = {
            'Village Land Use':ly_group,
            'Regional Land Use':ly_features,
            'Zonal Land Use':ly_features,
            'National Land Use':ly_features,
            'CCRO':ly_features,
            'Village Boundaries':ly_features,
            'Conceptial Diagrams':ly_features,
            'Others':ly_features
        }*/
        let filter = 'project_id='+this.props.project.id
        let layername = 'project_parcel'

        let selected = ''


        Wait.show("Loading Spatial...")
        api.get(GeoServer.API_URL+'/ows?cql_filter='+filter+'&service=WFS&version=1.0.0&request=GetFeature&typeName='+layername+'&outputFormat=application%2Fjson').then(r=>{
            Wait.dismiss()
            try {
                        console.log(r.data)
                        r.data.features.forEach(p=>{

                            let myLayer = LF.geoJSON(p,{
                                onEachFeature:(f,l)=>{
                                    LF.marker(l.getBounds().getCenter(),{
                                        icon:LF.divIcon({
                                            className:'bindTooltipBig',
                                            html:f.properties.claim_no,
                                            iconSize:[100,40]
                                        })
                                    }).addTo(ly_labels)
                                    l.setStyle({
                                        color:f.properties.status==='occupied'?'#000':'#f80',
                                        fillColor:f.properties.status==='occupied'?'#000':'#f80',
                                         fillOpacity: f.properties.status==='occupied'?0.4:0,
                                    })
                                },
                                /*coordsToLatLng: function (coords) {
                                    return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();
                                },*/
                                weight:3,zIndex:2,

                            }).on('dblclick',e=>{


                            }).on('click', function (e) {

                                if (e.layer.feature.properties.status==="occupied"){
                                    alert('Occupied')
                                    return
                                }
                                //if (selected) {e.target.resetStyle(selected)}
                                selected = e.layer


                                let arr = self.state.selected_plots
                                let new_arr = self.state.selected_plots
                                let description = self.state.description
                                let new_desr = self.state.description

                                let id = parseInt(e.layer.feature.id.split('.')[1])
                                let claim = e.layer.feature.properties.claim_no

                                if (arr.includes(id)){
                                    new_arr = []
                                    new_desr = []
                                    arr.forEach(it=>{
                                        if (it!==id){
                                            new_arr.push(it)
                                        }
                                    })
                                    description.forEach(it=>{
                                        if (it!==claim){
                                            new_desr.push(claim)
                                        }
                                    })
                                    selected.setStyle({color: '#f80', weight:4})
                                }else{
                                    selected.setStyle({color: '#00f', weight:4})
                                    map.fitBounds(selected.getBounds())
                                    new_arr.push(id)
                                    new_desr.push(claim)
                                }

                                self.setState({
                                    selected_plots:new_arr,
                                    description:new_desr
                                })

                                selected.bringToFront()

                            })
                            myLayer.addTo(ly_plots)
                        })
                        //let myLayer = LF.geoJSON(r.data,{coordsToLatLng: function (coords) {return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();}})
                        let myLayer = LF.geoJSON(r.data)
                        try{ map.fitBounds(myLayer.getBounds())}catch (e) { }
                    }catch (e){
                        console.log(e)
                    }
        })


        layername = 'point_spatial'
        api.get(GeoServer.API_URL+'/ows?cql_filter='+filter+'&service=WFS&version=1.0.0&request=GetFeature&typeName='+layername+'&outputFormat=application%2Fjson').then(r=>{
            Wait.dismiss()
            try {
                        ///console.log(r.data)
                        r.data.features.forEach(p=>{
                            let myLayer = LF.geoJSON(p,{
                                onEachFeature:(f,l)=>{
                                    //console.log(l._latlng)
                                    LF.marker(l._latlng,{
                                        icon:LF.divIcon({
                                            className:'bindTooltipBig',
                                            html:f.properties.description,
                                            iconSize:[100,40]
                                        })
                                    }).addTo(ly_beacons)
                                   /* l.setStyle({
                                        color:f.properties.status==='Approved'?'#00ff00':'#901'
                                    })*/
                                },
                                coordsToLatLng: function (coords) {
                                    return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();
                                },
                                weight:3,zIndex:2, fillOpacity: 0
                            }).on('dblclick',e=>{


                            }).on('click', function (e) {


                            })
                            //myLayer.addTo(ly_group)
                        })
                    }catch (e){
                        console.log(e)
                    }
        })


        let overlays = {
            'Plots':ly_plots,
            'Labels':ly_labels,
            'Beacons':ly_beacons,

        }


        UgSpatial.layers = LF.control.layers(baseLayers,overlays, {position: 'bottomleft'}).addTo(map)

        this.setState({
            selected_plots:[],
            description:[]
        })
    }
}
